function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_137",
  "data-name": "Rectangle 137",
  width: 26,
  height: 26,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_2182",
  "data-name": "Path 2182",
  d: "M928.771,141.09l-6.218,6.249a1.589,1.589,0,0,1-1.122.45,1.626,1.626,0,0,1-1.155-.452l-.545-.58a1.553,1.553,0,0,1-.48-1.129,1.622,1.622,0,0,1,.462-1.16l4.544-4.523-4.522-4.5a1.561,1.561,0,0,1-.484-1.153,1.541,1.541,0,0,1,.48-1.121l.545-.576a1.637,1.637,0,0,1,1.155-.449,1.593,1.593,0,0,1,1.122.45l6.218,6.249a1.55,1.55,0,0,1,0,2.245Z",
  transform: "translate(-911.252 -126.968)",
  fill: "currentColor"
});

function SvgIconArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_-_arrow_-_right",
    "data-name": "icon - arrow - right",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon-arrow-right.aa33d0e9.svg";
export { ForwardRef as ReactComponent };